module.exports = __webpack_public_path__ + "img/align-horizontal-centre-01.28d6d37a.svg";